import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormArray, FormControl, FormControlDirective, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import {identity, Observable} from 'rxjs';
import { CurrencyPipe, DatePipe, Location, NgLocaleLocalization } from '@angular/common';
import {map, startWith} from 'rxjs/operators';
import { ApiConfig } from 'src/app/utility/ApiConfig';
import Swal from 'sweetalert2';
import * as moment from 'moment';

export interface arrAccountNumber {account_number: string}
export interface arrAccountNumber2 {account_number2: string}


@Component({
  selector: 'app-add-antar-rekening',
  templateUrl: './add-antar-rekening.component.html',
  styleUrls: ['./add-antar-rekening.component.css']
})
export class AddAntarRekeningComponent implements OnInit {

  constructor(
    private http: HttpClient, 
    private router: Router, 
    private route: ActivatedRoute, 
    private ApiConfig: ApiConfig,
    private currencyPipe : CurrencyPipe
  ) { }

  transForm: FormGroup = new FormGroup({
    // transTOS_Sender: new FormArray([], [Validators.required]),
    // transTOS_Receiver: new FormArray([], [Validators.required]),
    transTOS_Sender: new FormControl({value: '', disabled: true}),
    transTOS_Receiver: new FormControl({value: '', disabled: true}),
    transDate: new FormControl({value: '', disabled: true}, [Validators.required]),
    transAccNoSender: new FormControl('', [Validators.required]),
    transNameSender: new FormControl({value: '', disabled: true}),
    transAccNoReceiver: new FormControl('', [Validators.required]),
    transNameReceiver: new FormControl({value: '', disabled: true}),
    transAmount: new FormControl('', [Validators.required]),
    transAmountText: new FormControl('', [Validators.required]),
    transNews: new FormControl('', [Validators.required]),
    transValid: new FormControl(''),
    transTOSText_Receiver: new FormControl(''),
    branch: new FormControl('', [Validators.required]),
    create_name: new FormControl('', [Validators.required]),
    cif_sender: new FormControl(''),
    cif_receiver: new FormControl(''),
  })

  httpOptions: any = {headers: new HttpHeaders({ 'Content-Type': 'application/json', 'token': this.ApiConfig.get("user-data").token })};
  responseApi: any; tempStore:any;
  arrTypeOfSavings_Sender = [
    {text: "Tabungan Nusantara"},
    {text: "Tabungan Nusantara Bisnis"},
    {text: "Tabungan Nusantara Karyawan"}
  ];

  arrTypeOfSavings_Receiver = [
    {text: "Tabungan Nusantara"},
    {text: "Tabungan Nusantara Bisnis"},
    {text: "Tabungan Nusantara Karyawan"},
    {text: "Lainnya"}
  ];

  dtAccountType = [{'text' : 'Tabungan Nusantara', 'id' : 'tabungan-nusantara'}, {'text' : 'Tabungan Nusantara Bisnis', 'id' : 'tabungan-nusantara-bisnis'}, {'text' : 'Tabungan Nusantara Karyawan', 'id' : 'tabungan-nusantara-karyawan'}]

  tempAccountNumber:any;

  arrAccountNumber:any;
  options: arrAccountNumber[] = [];
  options2: arrAccountNumber[] = [];
  filteredOptions: Observable<arrAccountNumber[]>;
  filteredOptions2: Observable<arrAccountNumber[]>;

  ngOnInit(): void {
    //this.addCheckboxes_TOSS();
    //this.addCheckboxes_TOSR();
    this.getAccountNumber();
    this.getStoreData();
    this.transForm.get("create_name").setValue(this.ApiConfig.USER_DATA.id_user);
    this.transForm.get("branch").setValue(parseInt(this.ApiConfig.USER_DATA.id_store));
    this.transForm.get("transDate").setValue(moment().format('YYYY-MM-DD'));
    
  }

  getStoreData(){
    this.http.get(this.ApiConfig.API_URL + "/store", this.httpOptions).subscribe(
      res => {
        this.responseApi = res;
        if(this.responseApi.status == "200"){
          // console.log(this.responseApi);
          let tempData = this.responseApi.data;
          this.tempStore = tempData.map(city => ({
            "id_store": parseInt(city.id_store),
            "store_name": city.store_name,
            "additional": city
          }));
        }
      }, 
      err => {
        console.log(err);
      }
    )
  }

  GetDataSender(){
    this.transForm.get('transTOS_Sender').setValue(this.transAccNoSender.value.account_type);
    this.transForm.get('transNameSender').setValue(this.transAccNoSender.value.full_name);
    this.transForm.get('cif_sender').setValue(this.transAccNoSender.value.no_first_cif);
  }
  
  GetDataReceiver(){
    this.transForm.get('transTOS_Receiver').setValue(this.transAccNoReceiver.value.account_type);
    this.transForm.get('transNameReceiver').setValue(this.transAccNoReceiver.value.full_name);
    this.transForm.get('cif_receiver').setValue(this.transAccNoReceiver.value.no_first_cif);
  }

  displayFn(user: arrAccountNumber): string {
    return user && user.account_number ? user.account_number : '';
  }

  private _filter(account_number: string): arrAccountNumber[] {
    const filterValue = account_number.toLowerCase();

    return this.options.filter(option => option.account_number.toLowerCase().includes(filterValue));
  }

  getAccountNumber(){
    this.http.get(this.ApiConfig.API_URL + "/daily-savings-table", this.httpOptions).subscribe(
      res => {
        this.responseApi = res;
        if(this.responseApi.status == "200"){
          this.tempAccountNumber = this.responseApi.data;
          // console.log(this.tempAccountNumber);
          this.filteredOptions =  new Observable<arrAccountNumber[]>();
          this.filteredOptions2 =  new Observable<arrAccountNumber[]>();
          this.options = this.tempAccountNumber;
          this.options2 = this.tempAccountNumber;
          this.filteredOptions = this.transAccNoSender.valueChanges.pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value.account_number),
            map(account_number => account_number ? this._filter(account_number) : this.options.slice())
          );
          this.filteredOptions2 = this.transAccNoReceiver.valueChanges.pipe(
            startWith(''),
            map(value => typeof value === 'string' ? value : value.account_number),
            map(account_number => account_number ? this._filter(account_number) : this.options2.slice())
          );
        }
      }, 
      err => {
        console.log(err);
      }
    )
  }

  get TOSSFormArray() {
    return this.transForm.controls.transTOS_Sender as FormArray;
  }

  get TOSRFormArray() {
    return this.transForm.controls.transTOS_Receiver as FormArray;
  }

  private addCheckboxes_TOSS() {
    this.arrTypeOfSavings_Sender.forEach(() => this.TOSSFormArray.push(new FormControl(false)));
  }

  private addCheckboxes_TOSR() {
    this.arrTypeOfSavings_Receiver.forEach(() => this.TOSRFormArray.push(new FormControl(false)));
  }

  valNumber(event:any){
    var ASCIICode = (event.which) ? event.which : event.keyCode
    if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
        return false;
    return true;
  }

  changeTOSReceiver(event:any){
    // console.log(event);
    this.transTOS_Receiver.markAsTouched();
    if(event.path[0].checked && event.path[1].innerText.trim() == 'Lainnya'){
      $("#inline-full-TOSOthers").css("display", "block");
    }
    if(!(event.path[0].checked) && event.path[1].innerText.trim() == 'Lainnya'){
      $("#inline-full-TOSOthers").css("display", "none");
      this.transTOSText_Receiver.markAsUntouched();
    }
  }

  getRupiahFormat(event:any){
    this.transAmount.setValue(this.formatRupiah(this.transAmount.value));
  }

  formatRupiah(angka:any){
    let prefix = "Rp. ";
    let separator:any;
    let number_string = angka.replace(/[^,\d]/g, '').toString(),
			split   		= number_string.split(','),
			sisa     		= split[0].length % 3,
			rupiah     		= split[0].substr(0, sisa),
			ribuan     		= split[0].substr(sisa).match(/\d{3}/gi);
 
			// tambahkan titik jika yang di input sudah menjadi angka ribuan
			if(ribuan){
				separator = sisa ? '.' : '';
				rupiah += separator + ribuan.join('.');
			}
 
			rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
			return prefix == undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
  }

  validateForm(){
    const invalid = [];
    const controls = this.transForm.controls;

    for (const name in controls) {
      if (controls[name].invalid) {
 console.log(name);
        this.transForm.markAllAsTouched();
        return false;
      }
    }
    return true;
  }

  addTransfer(){
    if(this.validateForm()){
      let cif_sender = this.cif_sender.value;
      let cif_receiver = this.cif_receiver.value;
      let transNameSender = this.transNameSender.value;
      let transNameReceiver = this.transNameReceiver.value;
      let amount = this.transAmount.value;
      amount = amount.replace(/Rp. /g, "");
      amount = amount.replace(/\./g, "");
      let note = this.transNews.value;
      let create_operator = this.create_name.value;
      let objSender = {"cif_id" : cif_sender, "amount" : amount, "type" : "D", "note" : "transfer dana ke " + transNameReceiver + " : " + note, "create_operator" : create_operator};
      let objReceiver = {"cif_id" : cif_receiver, "amount" : amount, "type" : "K", "note" : "terima dana dari " + transNameSender + " : " + note, "create_operator" : create_operator};
      // console.log(objSender);
      // console.log(objReceiver);

      this.http.post(this.ApiConfig.API_URL + "/insert-log-daily-savings-transactions", objSender, this.httpOptions).subscribe(res => {
        this.responseApi = res;
        if (this.responseApi.status == "200") {
          this.http.post(this.ApiConfig.API_URL + "/insert-log-daily-savings-transactions", objReceiver, this.httpOptions).subscribe(res => {
            this.responseApi = res;
            if (this.responseApi.status == "200") {
              this.http.post(this.ApiConfig.API_URL + "/insert-transfer-transaction", this.transForm.value, this.httpOptions).subscribe(res => {
                this.responseApi = res;
                if (this.responseApi.status == "200") {
                  Swal.fire("Success", "Transfer Berhasil", "success").then(() => {
                    this.router.navigate(['/admin']);
                  })
                } else {
                  Swal.fire("Ooops", "Gagal Transfer. Mohon Coba Lagi.", "error");
                }
              }, err => {
                Swal.fire("Ooops", "Gagal Transfer. Mohon Coba Lagi.", "error");
              });
            } else {
              Swal.fire("Ooops", "Gagal Transfer. Mohon Coba Lagi.", "error");
            }
          }, err => {
            Swal.fire("Ooops", "Gagal Transfer. Mohon Coba Lagi.", "error");
          });
        } else {
          Swal.fire("Ooops", "Gagal Transfer. Mohon Coba Lagi.", "error");
        }
      }, err => {
        Swal.fire("Ooops", "Gagal Transfer. Mohon Coba Lagi.", "error");
      });

      
    }
    
  }

  rupiahFormat(value){
    return this.currencyPipe.transform(value, 'Rp ');
  }

  printValidation(){
    let current = new Date();
    let strTime = current.getHours() + ":" + current.getMinutes() + ":" + current.getSeconds();
    let objAccNumber = this.transForm.get('transAccNoSender').value;
    let objAccNumberReceiver = this.transForm.get('transAccNoReceiver').value;
    // let currencyFormat = this.rupiahFormat(this.transForm.get('transAmount').value);
    let currencyFormat = this.transForm.get('transAmount').value;
    
    // if(currencyFormat != "" && currencyFormat != null){
    //   currencyFormat = currencyFormat.replace(".", "/");
    //   while(currencyFormat.indexOf(",") >= 0){
    //     currencyFormat = currencyFormat.replace(",", ".");
    //   }
    //   currencyFormat = currencyFormat.replace("/", ",");
    // }

    let currDate = new Date(this.transForm.get('transDate').value);
    let tempDate = currDate.getDate()+"-"+(currDate.getMonth()+1)+"-"+currDate.getFullYear();

    let a = window.open();
    a.document.write('<div id = "form-print" style = "display:block; font-size: 2mm; margin-top: 3cm; margin-left: 2cm;">');
    a.document.write('<table style = "font-size: 2.5mm;">');
    a.document.write('<tr><td>Tanggal</td><td style = "padding-left: 1mm"><p id = "print-date">: ' + tempDate + '</p></td>');
    a.document.write('<tr><td>Jam</td><td style = "padding-left: 1mm"><p id = "print-time">: ' + strTime + '</p></td>');
    a.document.write('<tr><td>Jumlah</td><td style = "padding-left: 1mm"><p id = "print-amount">: ' + currencyFormat + '</p></td>');
    a.document.write('<tr><td>Nomor Akun Pengirim</td><td style = "padding-left: 1mm"><p id = "print-account">: ' + objAccNumber.account_number + '</p></td>');
    a.document.write('<tr><td>Nomor Akun Penerima</td><td style = "padding-left: 1mm"><p id = "print-account">: ' + objAccNumberReceiver.account_number + '</p></td>');
    // a.document.write('<tr><td>Nama Akun</td><td style = "padding-left: 1mm"><p id = "print-accountname">: ' + this.transForm.get('account_name').value + '</p></td>');
    a.document.write('</table>');
    a.document.write('</div>');
    a.document.close();
    a.print();
  }

  get transTOS_Sender(){return this.transForm.get("transTOS_Sender")};
  get transTOS_Receiver(){return this.transForm.get("transTOS_Receiver")};
  get transDate(){return this.transForm.get("transDate")};
  get transAccNoSender(){return this.transForm.get("transAccNoSender")};
  get transNameSender(){return this.transForm.get("transNameSender")};
  get transAccNoReceiver(){return this.transForm.get("transAccNoReceiver")};
  get transNameReceiver(){return this.transForm.get("transNameReceiver")};
  get transAmount(){return this.transForm.get("transAmount")};
  get transAmountText(){return this.transForm.get("transAmountText")};
  get transNews(){return this.transForm.get("transNews")};
  get transValid(){return this.transForm.get("transValid")};
  get transTOSText_Receiver(){return this.transForm.get("transTOSText_Receiver")};
  get cif_sender(){return this.transForm.get("cif_sender")};
  get cif_receiver(){return this.transForm.get("cif_receiver")};
  get create_name(){return this.transForm.get("create_name")};
}
